import * as RIP from "react-international-phone";

import {defaultCountries} from "@/components/phone/PhoneInput.data.ts";

export const PhoneNumber = ({value}: {value: string}) => {
  const {inputValue} = RIP.usePhoneInput({
    defaultCountry: "us",
    countries: defaultCountries,
    value: value,
  });
  return <div>{inputValue}</div>;
};
